var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.69531 7.18494L11.6953 11.1849L12.3053 9.81494L3.30531 5.81494L2.69531 7.18494ZM12.7503 21.4999V10.4999H11.2503V21.4999H12.7503ZM12.3053 11.1849L21.3053 7.18494L20.6953 5.81494L11.6953 9.81494L12.3053 11.1849Z",
    fill: "#7B7D7F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.3203L3.75 6.98763V17.0124L12 20.6797L20.25 17.0124V6.98763L12 3.3203ZM11.939 20.7068C11.9389 20.7069 11.9391 20.7068 11.939 20.7068V20.7068ZM11.4514 1.92267C11.6241 1.84585 11.811 1.80615 12 1.80615C12.189 1.80615 12.3759 1.84585 12.5486 1.92267C12.5485 1.92262 12.5488 1.92272 12.5486 1.92267L20.9486 5.65667C21.187 5.76279 21.3899 5.93588 21.5321 6.15471C21.6742 6.37354 21.7499 6.62888 21.75 6.88982V17.11C21.7499 17.371 21.6742 17.6265 21.5321 17.8453C21.3899 18.0641 21.1874 18.2371 20.949 18.3432L12.549 22.0772C12.5489 22.0772 12.5491 22.0771 12.549 22.0772C12.3763 22.154 12.189 22.1939 12 22.1939C11.811 22.1939 11.6241 22.1542 11.4514 22.0773C11.4512 22.0773 11.4515 22.0774 11.4514 22.0773L3.05135 18.3433C2.81295 18.2372 2.61007 18.0641 2.46791 17.8453C2.32575 17.6265 2.25006 17.3711 2.25 17.1102V6.89001C2.25006 6.62906 2.32575 6.37354 2.46791 6.15471C2.61007 5.93588 2.8126 5.76294 3.051 5.65682L11.4514 1.92267Z",
    fill: "#7B7D7F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.81484 4.19532C6.98307 3.81681 7.4263 3.64635 7.80481 3.81459L16.4488 7.65659C16.6872 7.76271 16.8901 7.93581 17.0323 8.15464C17.1744 8.37348 17.2501 8.62881 17.2502 8.88976V12.4999C17.2502 12.9142 16.9144 13.2499 16.5002 13.2499C16.086 13.2499 15.7502 12.9142 15.7502 12.4999V8.98757L7.19557 5.1853C6.81706 5.01706 6.6466 4.57383 6.81484 4.19532Z",
    fill: "#7B7D7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/orderIcon.8ed37eddd3a018f8fc9d5ddf93c0cad4.svg";
export { ForwardRef as ReactComponent };